import type { Integration } from '../../../types/api';
import { FormField, FormLabel, FormInput } from '../../ui';

interface ForticsTabProps {
  integration: Integration | null;
}

function ForticsTab({ integration }: ForticsTabProps) {
  return (
    <div className="space-y-6">
      <FormField>
        <FormLabel htmlFor="fortics_url">URL Fortics</FormLabel>
        <FormInput id="fortics_url" name="fortics_url" defaultValue={integration?.fortics_url} />
      </FormField>

      <div className="grid grid-cols-2 gap-4">
        <FormField>
          <FormLabel htmlFor="fortics_user">Usuário</FormLabel>
          <FormInput id="fortics_user" name="fortics_user" defaultValue={integration?.fortics_user} />
        </FormField>

        <FormField>
          <FormLabel htmlFor="fortics_password">Senha</FormLabel>
          <FormInput
            type="password"
            id="fortics_password"
            name="fortics_password"
            defaultValue={integration?.fortics_password}
          />
        </FormField>
      </div>

      <FormField>
        <FormLabel htmlFor="fortics_token">Token</FormLabel>
        <FormInput id="fortics_token" name="fortics_token" defaultValue={integration?.fortics_token} />
      </FormField>
    </div>
  );
}

export default ForticsTab;
